"use client";

import { Form, Input, Button, Typography, message } from "antd";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import service from "../api/FetchInterceptor";

const { Title, Paragraph } = Typography;

const ResetPassword = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");
    const email = searchParams.get("email");

    const onSubmit = async (values) => {
        if (!token || !email) {
            message.error("Lien de réinitialisation invalide ou incomplet.");
            return;
        }

        setLoading(true);
        try {
            const response = await service({
                method: "POST",
                url: "reset-password",
                data: {
                    token,
                    email,
                    password: values.password,
                    password_confirmation: values.password_confirmation,
                },
            });

            message.success(response.message || "Mot de passe réinitialisé.");
            navigate("/login");
        } catch (error) {
            message.error(
                error.response?.data?.message ||
                    "Impossible de réinitialiser le mot de passe."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col min-h-screen items-center justify-center md:bg-blue-50">
            <img src="/logo_black.png" alt="PSIE" className="w-50 -mt-32" />

            <div className="w-full max-w-xl mx-4 p-6 rounded-lg bg-white mt-8 shadow">
                <Title level={3}>Réinitialiser le mot de passe</Title>

                {!token || !email ? (
                    <Paragraph type="danger">
                        Ce lien de réinitialisation est invalide ou a expiré.
                        Veuillez refaire une demande.
                    </Paragraph>
                ) : (
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onSubmit}
                        className="mt-4"
                    >
                        <Form.Item label="Adresse e-mail">
                            <Input value={email} disabled size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Nouveau mot de passe"
                            name="password"
                            rules={[
                                { required: true, message: "Le mot de passe est requis" },
                                {
                                    min: 8,
                                    message: "Le mot de passe doit contenir au moins 8 caractères",
                                },
                            ]}
                            hasFeedback
                        >
                            <Input.Password placeholder="Nouveau mot de passe" size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Confirmer le mot de passe"
                            name="password_confirmation"
                            dependencies={["password"]}
                            hasFeedback
                            rules={[
                                { required: true, message: "Veuillez confirmer le mot de passe" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("password") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error("Les mots de passe ne correspondent pas")
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="Confirmez le mot de passe" size="large" />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            block
                            loading={loading}
                        >
                            Réinitialiser le mot de passe
                        </Button>
                    </Form>
                )}

                <Button
                    type="link"
                    className="mt-2 px-0"
                    onClick={() => navigate("/login")}
                >
                    Retour à la connexion
                </Button>
            </div>
        </div>
    );
};

export default ResetPassword;
